import { supabase } from '../../config/supabase';

/**
 * Subscribe to real-time job_production updates
 * @param {string} companyId - The company ID (not used for job_production, but kept for consistency)
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToProductionUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`job-production-changes`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'job_production'
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Subscribe to real-time job updates
 * @param {string} companyId - The company ID
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToJobUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`jobs-changes-${companyId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'jobs',
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Subscribe to real-time job_quotes updates (for delivery schedule)
 * @param {string} companyId - The company ID
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToJobQuotesUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`job-quotes-changes-${companyId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'job_quotes'
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Subscribe to real-time job_quotes updates (for delivery schedule)
 * @param {string} companyId - The company ID
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToJobDeliveriesUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`job-deliveries-changes-${companyId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'job_deliveries'
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Subscribe to real-time job_designers updates
 * @param {string} companyId - The company ID (used for channel uniqueness)
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToJobDesignersUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`job-designers-changes-${companyId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'job_designers'
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Subscribe to real-time job_estimators updates
 * @param {string} companyId - The company ID (used for channel uniqueness)
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToJobEstimatorsUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`job-estimators-changes-${companyId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'job_estimators'
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Unsubscribe from job updates
 */
export const unsubscribeFromJobUpdates = async (channel) => {
    if (channel) {
        await supabase.removeChannel(channel);
    }
};
